import { useState, useEffect, useRef } from 'react';
import { getSpeechOrchestrator } from '../Voice/SpeechOrchestrator';
import sanitizeInput from '../utils/sanitizeInput';
export const useChatbotState = props => {
  const {
    submitChatMessagesPayload,
    cachedMessages,
    cachedPrompts,
    setiValues,
    speechFetchRequestOptions,
    debugMode
  } = props;
  const [chatMessages, setChatMessages] = useState([...cachedMessages]);
  const [prompts, setPrompts] = useState([...cachedPrompts]);
  const [isLoading, setLoadingStatus] = useState(false);
  const [retrievalLoading, setRetrievalLoading] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [openErrorComponent, setOpenErrorComponent] = useState(false);
  const [santizedSubmitChatMessagesPayload, setSanitizedSubmitChatMessagesPayload] = useState(submitChatMessagesPayload);
  const [loadMoreMessages, setLoadMoreMessages] = useState(false);
  const [lastPromptId, setLastPromptId] = useState('');
  const [isMapOpened, setOpenedMap] = useState(false);
  const speechOrchestratorRef = useRef(null);
  const audioPlayerRef = useRef(null);
  // Sanitize the submitChatMessagesPayload when it changes
  useEffect(() => {
    if (submitChatMessagesPayload.pushPrompt) {
      const sanitizedPayload = Object.assign(Object.assign({}, submitChatMessagesPayload), {
        pushPrompt: sanitizeInput(submitChatMessagesPayload.pushPrompt)
      });
      setSanitizedSubmitChatMessagesPayload(sanitizedPayload);
    } else {
      setSanitizedSubmitChatMessagesPayload(submitChatMessagesPayload);
    }
  }, [submitChatMessagesPayload]);
  // Initialize Speech Orchestrator if voice is enabled
  useEffect(() => {
    if (setiValues === null || setiValues === void 0 ? void 0 : setiValues.enableVoice) {
      speechOrchestratorRef.current = getSpeechOrchestrator((speechFetchRequestOptions === null || speechFetchRequestOptions === void 0 ? void 0 : speechFetchRequestOptions.url) || '/genai-svc/genai/speech', (speechFetchRequestOptions === null || speechFetchRequestOptions === void 0 ? void 0 : speechFetchRequestOptions.timeout) || 10000, audioPlayerRef.current, debugMode);
      return () => {
        speechOrchestratorRef.current = null;
      };
    }
  }, [setiValues, speechFetchRequestOptions, debugMode]);
  return {
    chatMessages,
    setChatMessages,
    prompts,
    setPrompts,
    isLoading,
    setLoadingStatus,
    retrievalLoading,
    setRetrievalLoading,
    showSurvey,
    setShowSurvey,
    openErrorComponent,
    setOpenErrorComponent,
    santizedSubmitChatMessagesPayload,
    audioPlayerRef,
    setSanitizedSubmitChatMessagesPayload,
    speechOrchestratorRef,
    loadMoreMessages,
    setLoadMoreMessages,
    lastPromptId,
    setLastPromptId,
    isMapOpened,
    setOpenedMap
  };
};